
import { Component, Vue, Watch, Ref } from 'vue-property-decorator'
import { MediaService, MediaTagService } from '@/services/index'
import TableHeader from '@/components/table_header/index.vue'
import MediaTable from './components/mediaTable.vue'
import { Media } from '@/common/storage'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'
import { AppModule } from '@/store/modules/app'
import { convertCodeToText } from '@/common/area_data'
import { MediaStateStorage } from '@/common/utils'

@Component({
    name: 'MediaList',
    components: {
        MediaTable,
        TableHeader,
        ScrollTo
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private mediaList: any[] = []
    private mediaTypeList: any[] = []
    private searchQuery: string = ''
    private pageIndex: number = 1
    private pageSize: number = 50
    private pageTotal: number = 0
    private loading: boolean = false
    private tableHeaderDecs: string = ''
    private classStatus: number | string = ''
    private mediaTypes = []
    private mpTypeId = ''
    private region = ''
    private regionNumber: string[] = []
    private tagsList: any[] = []
    private selectedTagIds: number[] = []

    get provinceAndCityData() {
        return AppModule.provinceAndCity
    }

    get regionData() {
        return AppModule.regionData
    }

    private async mounted() {
        const pageIndex = Media.getMediaPageIndex()
        this.pageIndex = pageIndex ? Number(pageIndex) : this.pageIndex

        await this.fetchMediaTypes()
        await this.fetchRegion()
        await this.getMediaMpTypes()
        await this.fetchAllTags()
        this.restoreState()
        await this.fetchMediaList()
    }

    private async fetchMediaList(ordering?: string) {
        this.loading = true
        await this.requestData(ordering)
        this.loading = false
    }
    private async fetchMediaTypes() {
        const result = await MediaService.getMediaTypes()
        if (result.status === 200) {
            this.mediaTypeList = result.data
        }
    }

    private async requestData(ordering?: string) {
        const params : any =  {
            media_name: this.searchQuery,
            type: this.classStatus,
            ordering: ordering,
            mp_type_id: this.mpTypeId,
            region: this.region,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        // 如果有选择标签，则将标签ID数组转换为逗号分隔的字符串
        if (this.selectedTagIds.length > 0) {
            params.tag_ids = this.selectedTagIds.join(',')
        }
        const result = await MediaService.getList(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.mediaList = this.filterMediaList(result.data.media_list)
            this.tableHeaderDecs = '一共有 ' + this.pageTotal + ' 家'
            Media.setMediaPageIndex(this.pageIndex.toString())
        }
    }

    private filterMediaList(mediaList: any[]) {
        return mediaList.map(media => {
            let str = media.alias.join(',')
            media.origin_alias_str = str
            return media
        })
    }

    private async fetchRegion() {
        await AppModule.getRegion()
    }

    private async getMediaMpTypes() {
        const result = await MediaService.getMpTypeGroup()
        if (result.status === 200) {
            this.mediaTypes = result.data
        }
    }

    // 获取所有标签
    private async fetchAllTags() {
        const result = await MediaTagService.mediaTagSearch({ 'keyword': '' })
        if (result.status === 200 && result.data) {
            this.tagsList = result.data
        }
    }

    private onCurrentChange(page: any) {
        this.pageIndex = page
        this.saveState()
        this.scrollEl.scrollToTop(this.fetchMediaList)
    }

    private onCreate() {
        this.$router.push({ name: 'MediaCreate', query: { type: 'media' } })
    }

    private onSearch() {
        this.pageIndex = 1
        this.saveState()
        this.fetchMediaList()
    }

    private onClassStatusChange(status: number) {
        this.classStatus = status
        this.saveState()
        this.fetchMediaList()
    }

    private async onSelectRegion(value: any) {
        this.loading = true
        const region = convertCodeToText(value)
        this.region = region
        this.regionNumber = value
        this.saveState()
        await this.requestData()
        this.loading = false
    }

    private async onMeidaTypeChange(value: any) {
        this.loading = true
        this.mpTypeId = value
        this.saveState()
        await this.requestData()
        this.loading = false
    }

    // 标签选择变化
    private onTagChange(value: number[]) {
        this.selectedTagIds = value
        this.pageIndex = 1
        this.saveState()
        this.requestData()
    }

    // 监听搜索回车键
    private onKeyup(event: any) {
        if (event.keyCode === 38 || event.keyCode === 40) return
        if (event.keyCode === 13) {
            this.onSearch()
        }
    }

    @Watch('$route')
    routechange(to: any, from: any) {
        if (from.name === 'MediaCreate' || from.name === 'MediaEdit') {
            this.requestData()
        }
    }

    private restoreState() {
        const savedState = MediaStateStorage.getState()
        if (Object.keys(savedState).length > 0) {
            this.searchQuery = savedState.searchQuery || ''
            this.classStatus = savedState.classStatus || ''
            this.mpTypeId = savedState.mpTypeId || ''
            this.region = savedState.region || ''
            this.regionNumber = savedState.regionNumber || []
            this.selectedTagIds = savedState.selectedTagIds || []
            this.pageIndex = savedState.pageIndex || 1
        }
    }

    private saveState() {
        MediaStateStorage.saveState({
            searchQuery: this.searchQuery,
            classStatus: this.classStatus,
            mpTypeId: this.mpTypeId,
            region: this.region,
            regionNumber: this.regionNumber,
            selectedTagIds: this.selectedTagIds,
            pageIndex: this.pageIndex
        })
    }
}
